export enum UserType {
  None = <any>"None",
  User = <any>"User",
  EndUser = <any>"EndUser",
  Device = <any>"Device",
  B2BApplication = <any>"B2BApplication",
  GuestUPhone = <any>"GuestUPhone"
}

